export const CUSTOM_VIEW_VISIBILITY = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  TEAM: 'team',
};
